module.exports = __webpack_public_path__ + "static/media/banner1.2f2f3e6f.jpg";